import { FormattedMessage, useIntl } from 'react-intl';
import { Typography, XStack } from '@shinetools/sunshine-universal';

import { PlanIcon } from '../../PlanIcon';
import { Table } from '../../Table';

import { type MigrationContentComponent } from '..';

export const BasicToStartTable: MigrationContentComponent = ({ newPlan }) => {
  const { formatMessage } = useIntl();

  return (
    <Table
      highlightColumn={2}
      rows={[
        [
          null,
          <Table.Header
            title={formatMessage({
              id: 'pricing.migration.page.current',
            })}
          >
            <Typography.Text bold>Shine Basic</Typography.Text>
          </Table.Header>,
          <Table.Header
            title={formatMessage({
              id: 'pricing.migration.page.new',
            })}
          >
            <XStack alignItems="center" gap="$space.8">
              <PlanIcon planId={newPlan.id} />
              <Typography.Text bold>{newPlan.brandName}</Typography.Text>
            </XStack>
          </Table.Header>,
        ],
        [
          <Table.Header
            title={formatMessage({
              id: 'pricing.migration.page.tables.wallets',
            })}
          />,
          <Table.FeatureInfo isAvailable={false} />,
          <Table.FeatureInfo>1</Table.FeatureInfo>,
        ],
        [
          <Table.Header
            title={formatMessage({
              id: 'pricing.migration.page.tables.finance_dashboard',
            })}
          />,
          <Table.FeatureInfo isAvailable={false} />,
          <Table.FeatureInfo isAvailable={true} />,
        ],
        [
          <Table.Header
            title={formatMessage({
              id: 'pricing.migration.page.tables.virtual_cards',
            })}
          />,
          <Table.FeatureInfo isAvailable={false} />,
          <Table.FeatureInfo>
            <FormattedMessage id="pricing.migration.page.tables.virtual_cards.unlimited" />
          </Table.FeatureInfo>,
        ],
        [
          <Table.Header
            title={formatMessage({
              id: 'pricing.migration.page.tables.custom_invoices',
            })}
          />,
          <Table.FeatureInfo isAvailable={false} />,
          <Table.FeatureInfo isAvailable={true} />,
        ],
        [
          <Table.Header
            title={formatMessage({
              id: 'pricing.migration.page.tables.accountant_access',
            })}
          />,
          <Table.FeatureInfo isAvailable={false} />,
          <Table.FeatureInfo isAvailable={true} />,
        ],
      ]}
    />
  );
};
